import Radio from '@cred/react-editors/radio'
import { withFieldChangeEvent } from '@cred/react-analytics/hoc'

const RadioWithAnalytics = withFieldChangeEvent(Radio)

export default RadioWithAnalytics
